import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import PageHeading from "@components/zenith/ui/PageHeading";
import Tabs from "@components/zenith/ui/Tabs";

const Profile: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col gap-5">
      <PageHeading title={t("zenith.profile.title")} />
      <div className="rounded-lg border border-gray-200 bg-white">
        <Tabs
          label={t("zenith.profile.title")}
          tabs={[
            { label: t("zenith.profile.my_details"), to: "/zenith/profile/me" },
            {
              // The prototype's word, not the tenant's: see "Subscriber" in GLOSSARY.md.
              label: t("zenith.profile.subscriber_tab"),
              to: "/zenith/profile/subscriber",
            },
          ]}
        />
        <div className="p-6">
          <Outlet />
        </div>
      </div>
    </section>
  );
};

export default Profile;
